import {UserModel, PersonUserModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: UserModel = {
  id: '',
  tipoDocumentoId: '',
  tipoDocumento: '',
  numeroDocumento: '',
  empresaSubcontratistaId: '',
  empresaContratanteId: '',
  perfil: '',
  nombreUsuario: '',
  estado: '',
  estadoAcceso: '',
  usuario: '',
  nombres: '',
  apellidoPaterno: '',
  apellidoMaterno: '',
  email: '',
  telefono: '',
  perfilId: '',
  accion: '',
  cargo: '',
  usuarioMyWay: '',
  documentoPersonaIdentificadorId: '',
  centroCosto: '',
  createHuesped: false,
  permisos: false,
  createComensal: false,
  esHuesped: false,
  esComensal: false,
  tienePermisos:false,
  tieneAccesoComedor: false,
  colorPermisos: '',
  colorHuesped: '',
  colorComensal: '',
  colorAccesoComedor: '',
  envioCorreo:false,
  puedeEditarEstado: false,
  ...aditionalValues,
}

export const initValuesPersonByUser: PersonUserModel = {
  person: {
    id: '',
    tipoDocumento: '',
    numeroDocumento: '',
    email: '',
    telefono: '',
    telefono2: '',
    estado: '',
    fechaNacimiento: '',
    nombres: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    sexoId: '',
  },
}
